/**
 * App version format and order (dnm-work#170 Contract C1). The server is the authority; the console
 * uses these only to confirm a raised minimum and to catch mistakes before sending.
 */
const VERSION = /^(\d{1,4})\.(\d{1,4})\.(\d{1,4})(?:\+(\d{1,9}))?$/;

export function isAppVersion(value: string): boolean {
  return VERSION.test(value);
}

function parts(value: string): number[] {
  const m = VERSION.exec(value);
  if (!m) throw new Error('not an app version');
  return [Number(m[1]), Number(m[2]), Number(m[3]), Number(m[4] ?? 0)];
}

/** Negative, zero or positive: MAJOR, MINOR, PATCH, then BUILD (missing = 0), always as numbers. */
export function compareAppVersions(a: string, b: string): number {
  const x = parts(a);
  const y = parts(b);
  for (let i = 0; i < 4; i++) {
    if (x[i] !== y[i]) return x[i] - y[i];
  }
  return 0;
}

/** True when saving `next` blocks builds that were allowed before: the minimum goes up or is set for the first time. */
export function raisesMinimum(previous: string | null, next: string | null): boolean {
  if (next == null || !isAppVersion(next)) return false;
  if (previous == null || !isAppVersion(previous)) return true;
  return compareAppVersions(next, previous) > 0;
}
